<template>
  <div class="draft">
    <div class="draft__main">
      <template v-if="!loading">
        <div v-if="draftCampaigns.length > 0" class="draft__main__content">
          <div class="draft__main__content__left">
            <div class="draft__main__content__left__selection">
              <span :class="['selection-checkbox', selectAll ? 'checked' : '']" @click.stop="toggleCheckAllItem"><i class="icon-check"></i></span>
              <span class="draft__main__content__left__selection__text subhead">Select all draft</span>
            </div>
            <div v-for="campaign in draftCampaigns" :key="campaign.id" class="draft__main__content__left__campaigns">
              <span 
                :class="['selection-checkbox', 
                          !campaign.is_complete ? 'disabled' : '', 
                          selectedCampaign.includes(campaign.id) && campaign.is_complete ? 'checked' : '']" 
                @click.stop="campaign.is_complete ? toggleSelectCampaign(campaign) : ''">
                  <i class="icon-check"></i>
              </span>
              <div class="draft__main__content__left__campaigns__section">
                <div class="draft__main__content__left__campaigns__section__top">
                  <span class="campaign-title subhead">{{campaign.title}}</span>
                  <div class="draft__main__content__left__campaigns__section__top__price">
                    <span class="small-font price-text">Price</span>
                    <span class="price">{{campaign.calculate_estimate_price|formatMoney}}</span>
                  </div>
                </div>
                <div class="draft__main__content__left__campaigns__section__mid">
                  <span class="draft__main__content__left__campaigns__section__mid__subtitle small-font">Campaign detail :</span>
                  <div class="draft__main__content__left__campaigns__section__mid__info">
                    <div class="section-period">
                      <span class="section-key subhead">Period</span>
                      <span class="section-value subhead">{{displayPeriod(campaign.start, campaign.end)}}</span>
                    </div>
                    <div class="section-duration">
                      <span class="section-key subhead">Ads duration</span>
                      <span class="section-value subhead">{{displayDuration(campaign.duration)}}</span>
                    </div>
                    <div class="section-listings">
                      <span class="section-key subhead">Total listing</span>
                      <span class="section-value subhead">{{displayTotalItem(campaign.total_item)}}</span>
                    </div>
                    <div class="section-price">
                      <span class="section-key subhead">Price</span>
                      <span class="section-value subhead">{{campaign.calculate_estimate_price|formatMoney}}</span>
                    </div>
                  </div>
                </div>
                <div class="draft__main__content__left__campaigns__section__bottom">
                  <div :class="['incomplete', !campaign.is_complete ? 'show' : 'hidden']">
                    <span class="incomplete__text small-font">Incomplete campaign</span>
                    <adx-tooltip text="You need to complete all required fields in the campaign editor (e.g. campaign period, duration, etc)" :isLong="true">
                      <span slot="content">
                        <div class="incomplete__tooltip_icon">
                          <img src="/img/icons/ic-info@2x.png" alt="">
                        </div>
                      </span>
                    </adx-tooltip>
                  </div>
                  <div class="buttons">
                    <button type="button" class="secondary btn-small" @click.stop="toCampaignEditor(campaign.id)" :disabled="loading">Edit</button>
                    <button type="button" class="secondary btn-small" @click.stop="duplicateCampaign(campaign)" :disabled="loading">Duplicate</button>
                    <button type="button" class="secondary btn-small" @click.stop="setDeleteCampaign(campaign.id)" :disabled="loading">Delete</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="draft__main__content__right">
            <div :class="['draft__main__content__right__wrapper', summaryPosition]">
              <div class="draft__main__content__right__wrapper__summary">
                <div class="draft__main__content__right__wrapper__summary__subtitle subhead">Order Summary</div>
                <div class="draft__main__content__right__wrapper__summary__total_campaign">
                  <span class="selected-campaign subhead">{{selectedCampaign.length}} Campaign</span>
                  <span class="price subhead">{{campaignsPrice|formatMoney}}</span>
                </div>
                <div class="draft__main__content__right__wrapper__summary__tax">
                  <span class="tax subhead">PPN 10%</span>
                  <span class="price subhead">{{tax|formatMoney}}</span>
                </div>
              </div>
              <div class="draft__main__content__right__wrapper__total">
                <span class="draft__main__content__right__wrapper__total__text subhead">Total</span>
                <span class="price regular-font">{{total|formatMoney}}</span>
              </div>
              <div v-if="selectedCampaign.length == 0" class="draft__main__content__right__wrapper__warning">
                <p>Please select the campaign you want to pay</p>
              </div>
              <div class="draft__main__content__right__wrapper__checkout">
                <button 
                  type="button" 
                  :class="['primary', 'btn-large', 'btn-checkout-large', isCheckout ? 'disabled' : '']" 
                  :disabled="selectedCampaign.length == 0 || isCheckout"
                  @click="checkout">
                  Checkout
                  <adx-loading-circle v-if="isCheckout" class="loading-circle"/>
                </button>
                <button 
                  type="button" 
                  :class="['primary', 'btn-block', 'btn-checkout-block', isCheckout ? 'disabled' : '']" 
                  :disabled="selectedCampaign.length == 0 || isCheckout"
                  @click="checkout">
                  Checkout
                  <adx-loading-circle v-if="isCheckout" class="loading-circle"/>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="draft__main__empty">
          <div class="draft__main__empty__img">
            <img src="/img/notfound/img-empty-draft@2x.png" alt="">
          </div>
          <span class="draft__main__empty__text">Your draft is empty.</span>
        </div>
      </template>
      <template v-else>
        <div class="loading-container">
          <adx-loading />
        </div>
      </template>
    </div>
    <adx-modal
      :hide-close="true"
      v-if="modalDelete"
      title="Delete campaign from draft ?"
      type="small"
      @modal-close="closeAndGetData">
        <div slot="content" class="modal-delete">
          <p class="confirmation-text small-font">Do you want to remove this campaign and all its listing item ? <br/> Note : this action can’t be undo. </p>
          <div class="buttons">
            <button 
              type="button" 
              class="secondary btn-large" 
              @click.stop="cancelDeleteCampaign()" 
              :disabled="deleting">Cancel</button>
            <button
              type="button" 
              :class="['primary', 'btn-large', 'btn-delete', deleting ? 'disabled' : '']" 
              @click.stop="deleteCampaign()" 
              :disabled="deleting">
                Delete
                <adx-loading-circle v-if="deleting" class="loading-circle" />
              </button>
          </div>
        </div>
    </adx-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Tooltip from '@/components/Tooltip'
import Modal from '@/components/Modal'
import Loading from '@/components/Loading/Primary'
import LoadingCircle from '@/components/Loading/Secondary-white'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-draft',
  components: {
    'adx-tooltip': Tooltip,
    'adx-modal': Modal,
    'adx-loading': Loading,
    'adx-loading-circle': LoadingCircle
  },
  props: {

  },
  data() {
    return {
      selectAll: false,
      loading: false,
      isCheckout: false,
      deleting: false,
      deletedCampaign: null,
      selectedCampaign: [],
      incompleteCampaign: [2],
      summaryPosition: '',
      campaignsPrice: 0,
      tax: 0,
      total: 0,
      modalDelete: false,
      draftCampaigns: [],
      newLine: '<br />'
    }
  },
  computed: {
    
  },
  watch: {
  },
  beforeCreate() {

  },
  created() {
    Vue.$broker.$on("on-scroll", this.setSummaryPosition)
    this.getDraftCampaigns()
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    checkout(){
      (async () => {
        this.isCheckout = true
        let data = {
          'campaigns_id': this.selectedCampaign
        }
        const response = await api.post(apiV2.orderCreate, data, { needToken: true })
        if (response.status == 201) {
          if (response.data.upfront) {
            this.$router.push({name: 'orderdetail', params: { id: response.data.data.id }})
          } else {
            this.$router.push({name: 'transaction'})
          }
        } else {
          this.$notify({
            group: 'saved',
            title: 'Create Order Failed',
            text: response.data.message,
            type: 'danger',
            duration: 5000
          });
        }
        this.isCheckout = false
      })();
    },
    toggleCheckAllItem() {
      if (this.selectAll) {
        this.unselectAllItem()
      } else {
        this.selectAllItem()
      }
    },
    selectAllItem() {
      let total = 0
      this.selectedCampaign = []
      this.draftCampaigns.map((campaign) => {
        if (campaign.is_complete) {
          this.selectedCampaign.push(campaign.id)
          total += campaign.calculate_estimate_price
        }
      })
      let campaignsPrice = Math.round((100/110) * total)
      let tax = total - campaignsPrice
      this.campaignsPrice = campaignsPrice
      this.tax = tax
      this.total = total
      this.selectAll = true
    },
    unselectAllItem() {
      this.selectedCampaign = []
      this.campaignsPrice = 0
      this.tax = 0
      this.total = 0
      this.selectAll = false
    },
    toggleSelectCampaign(campaign) {
      let price = Math.round((100/110) * campaign.calculate_estimate_price)
      let tax = campaign.calculate_estimate_price - price
      if (this.selectedCampaign.includes(campaign.id)) {
        let index = this.selectedCampaign.indexOf(campaign.id)
        this.selectedCampaign.splice(index, 1)
        this.campaignsPrice -= price
        this.tax -= tax
      } else {
        this.selectedCampaign.push(campaign.id)
        this.campaignsPrice += price
        this.tax += tax
      }
      this.total = this.campaignsPrice + this.tax
      let incompleteCampaign = this.draftCampaigns.filter((campaign) => {
        return campaign.is_complete == false
      })
      if ((this.draftCampaigns.length - incompleteCampaign.length) == this.selectedCampaign.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    isIncomplete(id) {
      if (this.incompleteCampaign.includes(id)) {
        return true
      }

      return false
    },
    setSummaryPosition() {
      let scrollTop = this.$root.$el.scrollTop
      if (scrollTop >= 140) {
        this.summaryPosition = 'fixed'
      } else {
        this.summaryPosition = ''
      }
    },
    displayPeriod(start, end) {
      if (start && end) {
        start = formatShortDate(start)
        end = formatShortDate(end)
        return `${start} - ${end}`
      } 

      return '-'
    },
    displayDuration(duration) {
      return `${duration} seconds`
    },
    displayTotalItem(count) {
      if (count == 0) {
        return '-'
      }

      return `${count} items`
    },
    toggleModal() {
      this.modalDelete = !this.modalDelete
    },
    closeAndGetData() {
      this.toggleModal()
      this.getDraftCampaigns()
    },
    toCampaignEditor(id) {
      this.$router.push({ name: 'campaigneditorpage', params: {id: id}})
    },
    setDeleteCampaign(id) {
      this.deletedCampaign = id
      this.toggleModal()
    },
    cancelDeleteCampaign() {
      this.deletedCampaign = null
      this.toggleModal()
    },
    duplicateCampaign(campaign) {
      (async () => {
        this.loading = true
        const response = await api.post(apiV2.duplicateCampaign(campaign.id), {}, { needToken: true })
        if (response.status == 201) {
          this.$notify({
            group: 'saved',
            title: 'Duplicate campaign success',
            text: campaign.title + ' has been duplicated to a new campaign',
            type: 'success',
            duration: 5000
          });
          this.getDraftCampaigns()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Duplicate campaign failed',
            text: response.data.message,
            type: 'danger',
            duration: 5000
          });
        }
      })();
    },
    getDraftCampaigns() {
      (async () => {
        this.loading = true
        const response = await api.get(apiV2.draftCampaigns, { needToken: true })
        if (response.status == 200) {
          this.draftCampaigns = response.data
          this.loading = false
        } else {

        }
      })();
    },
    deleteCampaign() {
      (async () => {
        this.deleting = true
        const response = await api.patch(apiV2.deleteCampaign(this.deletedCampaign), {}, { needToken: true })
        if (response.status == 200) {
          this.deletedCampaign = null
          this.deleting = false
          this.closeAndGetData()
        } else {

        }
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
.incomplete .tooltip {
  &.top .tooltiptext {
    bottom: 120%;
  }
}

.draft {
  .modal {
    .modal__content__header {
      margin-bottom: 0;
      padding: 0 32px;
    }
  }
}
</style>
